/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Photos_Input_ReorderInputs */

const en_admin_resources_photos_input_reorder = /** @type {(inputs: Admin_Resources_Photos_Input_ReorderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drag to reorder photos`)
};

const de_admin_resources_photos_input_reorder = /** @type {(inputs: Admin_Resources_Photos_Input_ReorderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotos per Drag & Drop sortieren`)
};

const es_admin_resources_photos_input_reorder = /** @type {(inputs: Admin_Resources_Photos_Input_ReorderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrastra para reordenar las fotos`)
};

const fr_admin_resources_photos_input_reorder = /** @type {(inputs: Admin_Resources_Photos_Input_ReorderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glissez pour réorganiser les photos`)
};

const nl_admin_resources_photos_input_reorder = /** @type {(inputs: Admin_Resources_Photos_Input_ReorderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sleep om foto's te herschikken`)
};

/** @type {(inputs: Admin_Resources_Photos_Input_ReorderInputs) => LocalizedString} */
const it_admin_resources_photos_input_reorder = en_admin_resources_photos_input_reorder;

/** @type {(inputs: Admin_Resources_Photos_Input_ReorderInputs) => LocalizedString} */
const pt_br2_admin_resources_photos_input_reorder = en_admin_resources_photos_input_reorder;

/** @type {(inputs: Admin_Resources_Photos_Input_ReorderInputs) => LocalizedString} */
const pl_admin_resources_photos_input_reorder = en_admin_resources_photos_input_reorder;

/** @type {(inputs: Admin_Resources_Photos_Input_ReorderInputs) => LocalizedString} */
const hu_admin_resources_photos_input_reorder = en_admin_resources_photos_input_reorder;

/** @type {(inputs: Admin_Resources_Photos_Input_ReorderInputs) => LocalizedString} */
const ro_admin_resources_photos_input_reorder = en_admin_resources_photos_input_reorder;

/**
* | output |
* | --- |
* | "Drag to reorder photos" |
*
* @param {Admin_Resources_Photos_Input_ReorderInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_photos_input_reorder = /** @type {((inputs?: Admin_Resources_Photos_Input_ReorderInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Photos_Input_ReorderInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_photos_input_reorder(inputs)
	if (locale === "de") return de_admin_resources_photos_input_reorder(inputs)
	if (locale === "es") return es_admin_resources_photos_input_reorder(inputs)
	if (locale === "fr") return fr_admin_resources_photos_input_reorder(inputs)
	if (locale === "nl") return nl_admin_resources_photos_input_reorder(inputs)
	if (locale === "it") return it_admin_resources_photos_input_reorder(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_photos_input_reorder(inputs)
	if (locale === "pl") return pl_admin_resources_photos_input_reorder(inputs)
	if (locale === "hu") return hu_admin_resources_photos_input_reorder(inputs)
	return ro_admin_resources_photos_input_reorder(inputs)
});
export { admin_resources_photos_input_reorder as "admin.resources.photos_input.reorder" }